import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { LOYALTY_CONTENT_ACTION_TYPE } from "./loyalty-content.action";
import { LoyaltyContentState } from "./loyalty-content.model";

const INITIAL_STATE: LoyaltyContentState = {
	memberLevels: undefined,
	earnPoints: undefined,
};

export function loyaltyContentReducer(state = INITIAL_STATE, action: ActionWithPayload): LoyaltyContentState {
	switch (action.type) {
		case LOYALTY_CONTENT_ACTION_TYPE.getMemberLevelsSuccess: {
			return updateState(state, {
				memberLevels: action.payload,
			});
		}
		case LOYALTY_CONTENT_ACTION_TYPE.getEarnPointsSuccess: {
			return updateState(state, {
				earnPoints: action.payload,
			});
		}
		default:
			return state;
	}
}
